module.exports = __webpack_public_path__ + "static/02-1642626143f7c36c64ec52e3cf3fd45e.jpg";